const HeaderButtons = () => {
  return <div></div>;
};

export default HeaderButtons;
